import { render } from "./ClassificationView.vue?vue&type=template&id=5577b824"
import script from "./ClassificationView.vue?vue&type=script&lang=js"
export * from "./ClassificationView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__